import Page from 'Scripts/classes/Page'
import Carousel from 'Scripts/animations/Carousel/index'
import Timeline from 'Scripts/animations/Timeline/index'
import { deviceType } from 'Scripts/utils/utils'
//Vendors
import { gsap } from 'gsap'

export default class extends Page {
  constructor({ scroller }) {
    super('groupe', {
      container: '.groupe',
      elements: {
        cursor: '.cursor.small circle',
        valeursList: '.valeur__list',
        valeurs: '.valeur__list .valeur__item',
        histoireWrapper: '.histoire__wrapper',
        histoireTitle: '.histoire__title',
        historyBg: '.histoire__bg',
        historyDates: '.histoire__item_date',
        historyList: '.histoire__list',
        historyItem: '.histoire__item',
        keysList: '.keys__list',
        keysItems: '.keys__item',
        marquee: '[data-animate=marquee]',
        filialeWrapper: '.filiale__wrapper',
      },
    })

    this.scroller = scroller
    this.device = deviceType()
    //
    this.initValue()
    this.handleValueClick()

    this.elements.valeurs && this.showValue(this.elements.valeurs[0], 0)

    this.addEventListener()

    this.update()
  }

  initValue() {
    const ww = window.innerWidth
    const titleWidth = 120
    const count = 4
    const wrapperWidth = 1240
    const maxWidth = ww > wrapperWidth ? wrapperWidth : ww

    this.reste = maxWidth - titleWidth * count
    // console.log(`reste : ${this.reste}`)
  }

  addEventListener() {
    // window.addEventListener('mousewheel', this.onWheel.bind(this))
    // window.addEventListener('wheel', this.onWheel.bind(this))
    this.elements.valeursList.addEventListener('mouseenter', this.onMouseenter.bind(this))
    this.elements.valeursList.addEventListener('mouseleave', this.onMouseLeave.bind(this))
  }

  onMouseenter() {
    // console.log('mouseenter')
    this.elements.cursor.style.fill = '#fff'
  }

  onMouseLeave() {
    // console.log('mouseleave')
    this.elements.cursor.style.fill = '#ffa900'
  }

  handleValueClick() {
    // console.log(this.elements.valeurs)
    this.elements?.valeurs?.forEach((valeur, index) => {
      valeur.querySelector('.valeur__item_title')?.addEventListener('click', () => {
        //Check if the title is active
        if (valeur.classList.contains('active')) {
          return
        }
        const activeValeur = gsap.utils
          .toArray(this.elements.valeurs)
          ?.find((elm) => elm.classList.contains('active'))
        //

        //remove active class from the other titles
        this.elements.valeurs.forEach((elm) => {
          if (elm !== valeur) {
            elm.classList.remove('active')
          }
        })
        //hide active Value before run show clicked Value
        if (activeValeur) {
          // this.hideValue(activeValeur)
          //   .then(() => {
          //     this.showValue(valeur, index)
          //   })
          this.hideValue(activeValeur)
          this.showValue(valeur, index)
        } else {
          this.showValue(valeur, index)
        }
      })
    })
  }

  showValue(elm, index) {
    const img = elm.querySelector('img')
    const text = elm.querySelector('.valeur__descriptif')
    //add active class to the title
    elm.classList.add('active')

    //use height if mobile and width if desktop
    if (this.device === 'mobile') {
      gsap.to(elm, {
        duration: 0.5,
        height: 'auto',
        onComplete: () => {
          gsap.to([img, text], {
            duration: 0.5,
            autoAlpha: 1,
            y: '0%',
            stagger: 0.1,
          })
        },
      })
    } else {
      // console.log(elm,index)
      //repositionnement des valeurs, active index will get the title width + reste

      this.elements.valeurs.forEach((elm, i) => {
        if (i === 0) {
          this.left = 0
        } else if (index + 1 == i) {
          this.left += 120 + parseInt(this.reste)
        } else {
          this.left += 120
        }

        gsap.to(elm, {
          duration: 0.5,
          left: this.left,
          onComplete: () => {
            gsap.to([img, text], {
              duration: 0.5,
              autoAlpha: 1,
              y: '0%',
              stagger: 0.1,
            })
          },
        })
      })

      // gsap.to(elm, {
      //   duration: 0.5,
      //   width: 'auto',
      //   onComplete: () => {
      //     gsap.to([img, text], {
      //       duration: 0.5,
      //       autoAlpha: 1,
      //       y: '0%',
      //       stagger: 0.1,
      //     })
      //   }
      // })
    }
  }

  hideValue(elm) {
    const img = elm.querySelector('img')
    const text = elm.querySelector('.valeur__descriptif')
    //return a promise
    return new Promise((resolve, reject) => {
      // gsap.to([img, text], {
      //   duration: 0.5,
      //   autoAlpha: 0,
      //   y: '50px',
      //   stagger: 0.1,
      //   onComplete: () => {
      //     gsap.to(elm, {
      //       duration: 0.5,
      //       width: '120px',
      //       onComplete: () => {
      //         resolve()
      //       }
      //     })
      //   }
      // })

      if (this.device === 'mobile') {
        gsap.to(elm, {
          duration: 0.5,
          height: '100px',
          onComplete: () => {
            resolve()
            gsap.set([img, text], {
              autoAlpha: 0,
              y: '50px',
            })
          },
        })
      } else {
        gsap.to([img, text], {
          autoAlpha: 0,
          y: '50px',
          duration: 0.5,
          stagger: 0.1,
          onComplete: () => resolve(),
        })
        // gsap.to(elm, {
        //   duration: 0.5,
        //   width: '120px',
        //   onComplete: () => {
        //     resolve()
        //     gsap.set([img, text], {
        //       autoAlpha: 0,
        //       y: '50px'
        //     })

        //   }
        // })
      }
    })
  }

  /**
   * Animations.
   */

  show() {
    //marquee
    // this.elements.marquee &&
    //   new Marquee()

    //chiffres cles
    this.elements.keysList &&
      new Carousel({
        wrapper: '.keys__list',
        carouselSelector: '.keys__list',
        mediasSelector: '.keys__item',
      })

    //Nos filiales
    this.elements.filialeWrapper &&
      new Carousel({
        wrapper: '.filiale__wrapper',
        carouselSelector: '.filiale__wrapper',
        mediasSelector: '.filiale__item',
      })
    //timeline
    this.elements.histoireWrapper &&
      new Timeline({
        scroller: this.scroller,
        element: this.elements.histoireWrapper,
        elements: {
          list: this.elements.historyList,
          items: this.elements.historyItem,
          bg: this.elements.historyBg,
          dates: this.elements.historyDates,
          title: this.elements.histoireTitle,
        },
      })
    return super.show()
  }

  hide() {
    return super.hide()
  }

  onResize() {
    return super.onResize()
  }
}
